(() => {
  if (window.TZCardSwatches) return;
  const bound = new WeakSet();
  const desktop = () => matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
  const navigate = raw => {
    if (!raw) return;
    const url = new URL(raw, location.origin);
    if (url.origin === location.origin && url.pathname.includes('/products/')) location.assign(url.href);
  };
  const bind = ({ container, selector, preview, key }) => {
    if (bound.has(container)) return;
    bound.add(container);
    container.dataset.tzSwatches = 'ready';
    container.querySelectorAll(selector).forEach(swatch => swatch.setAttribute('data-tz-swatch', ''));
    let armed = null, activation = 0;
    const get = event => {
      const swatch = event.target.closest(selector);
      return swatch && container.contains(swatch) && !swatch.disabled ? swatch : null;
    };
    const show = async swatch => {
      const url = await preview(swatch);
      if (url) container.dataset.tzSwatchPreview = 'true';
      return url;
    };
    container.addEventListener('pointerover', event => {
      const swatch = get(event);
      if (swatch && event.pointerType !== 'touch' && desktop() && !swatch.contains(event.relatedTarget)) show(swatch);
    });
    container.addEventListener('focusin', event => {
      const swatch = get(event);
      if (swatch && swatch.matches(':focus-visible')) show(swatch);
    });
    container.addEventListener('click', async event => {
      const swatch = get(event);
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      const identity = key(swatch);
      const request = ++activation;
      const url = await show(swatch);
      if (!url || request !== activation) return;
      if ((event.detail !== 0 && event.pointerType !== 'touch' && desktop()) || armed === identity) {
        navigate(url);
      } else {
        armed = identity;
      }
    }, true); // Capture before Motion's direct anchor transition handler.
  };
  const syncSecondary = (card, swatch) => {
    if (!swatch.hasAttribute('data-ss26-swatch-secondary')) return;
    const src = swatch.dataset.ss26SwatchSecondary?.trim();
    const box = card.querySelector('.grid-product__secondary-image');
    const img = box?.querySelector('img');
    if (!img) return;
    box.hidden = !src;
    if (src) { img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.src = src; img.setAttribute('data-src', src); }
    card.dataset.tzVerifiedSecondary = src ? 'true' : 'false';
  };
  window.TZCardSwatches = { bind, syncSecondary };
  const scanNative = () => {
    if (document.querySelector('[data-ss26-grid-tabs]')) return;
    document.querySelectorAll('.grid-product').forEach(card => {
      if (card.closest('[data-ev-family]') || !card.querySelector('a[data-ss26-card-swatch][data-ss26-swatch-url]')) return;
      bind({ container: card, selector: 'a[data-ss26-card-swatch]', key: swatch => swatch.dataset.ss26SwatchColor,
        preview: swatch => {
          const url = swatch.dataset.ss26SwatchUrl, src = swatch.dataset.ss26SwatchImage;
          if (!url || !src) return null;
          const img = card.querySelector('[data-ss26-card-primary-media] img');
          if (img) { img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.src = src; img.setAttribute('data-src', src); }
          card.querySelectorAll('[data-ss26-card-link],.grid-product__link').forEach(link => link.href = url);
          card.querySelectorAll('[data-ss26-card-swatch]').forEach(item => {
            const selected = item === swatch;
            item.classList.toggle('is-active', selected);
            if (selected) item.setAttribute('aria-current', 'true'); else item.removeAttribute('aria-current');
          });
          const label = card.querySelector('[data-ss26-card-color]');
          if (label) label.textContent = swatch.dataset.ss26SwatchColor;
          syncSecondary(card, swatch);
          card.classList.add('is-ss26-swatch-preview');
          return url;
        }
      });
    });
  };
  scanNative();
  new MutationObserver(records => { if (records.some(record => record.addedNodes.length)) scanNative(); }).observe(document.body, { childList: true, subtree: true });
})();

